import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import { AuthenticationContext } from "./AuthenticationWrap";
import { UserRole } from "../../../models/User";

export default function PrivateRoute(props: {
	children: JSX.Element | JSX.Element[] | string | string[];
	emptyComponent?: JSX.Element | string;
	/** When true, only UserRole.Admin may see children (station/partner sessions are signed out). */
	requireAdmin?: boolean;
}): JSX.Element {
	const location = useLocation();
	const path = location ? location.pathname + location.search : "";

	const ctx = useContext(AuthenticationContext);
	const { isValidated, isFinishedValidate, forceLogout, userInfo, token } = ctx || {};
	const requireAdmin = Boolean(props.requireAdmin);
	const [timeoutReached, setTimeoutReached] = useState(false);
	const sessionPurgeRequestedRef = useRef(false);

	const lacksAdminAccess =
		requireAdmin &&
		isFinishedValidate &&
		isValidated &&
		(!userInfo || Number(userInfo.role) !== UserRole.Admin);

	useEffect(() => {
		const timer = setTimeout(() => {
			setTimeoutReached(true);
		}, 5000);

		return () => clearTimeout(timer);
	}, []);

	useEffect(() => {
		if (isValidated) {
			sessionPurgeRequestedRef.current = false;
		}
	}, [isValidated]);

	useEffect(() => {
		if (!isFinishedValidate || isValidated) return;
		// Avoid forceLogout for guests who never had a token (same as whalelo-frontend PrivateRoute).
		if (!token) return;
		if (sessionPurgeRequestedRef.current) return;
		sessionPurgeRequestedRef.current = true;
		// forceLogout(backUrl, targetUrl): redirect only runs when targetUrl is truthy.
		forceLogout?.(path, "/");
	}, [isValidated, isFinishedValidate, token, forceLogout, path]);

	useEffect(() => {
		if (lacksAdminAccess) {
			forceLogout?.(path, "/");
		}
	}, [lacksAdminAccess, forceLogout, path]);

	const adminOk =
		!requireAdmin || (!!userInfo && Number(userInfo.role) === UserRole.Admin);

	if (isFinishedValidate && isValidated && adminOk) {
		return <Fragment>{props?.children}</Fragment>;
	}

	if (!isFinishedValidate && !timeoutReached) {
		return <div>Loading...</div>;
	}

	if (timeoutReached || (isFinishedValidate && !isValidated) || lacksAdminAccess) {
		return (
			<div style={{ textAlign: "center", padding: "50px" }}>
				<h2>Vui lòng đăng nhập</h2>
				<p>Bạn cần đăng nhập tài khoản quản trị để sử dụng khu vực này.</p>
			</div>
		);
	}

	return <div>Loading...</div>;
}
